import React, { useState } from 'react';
import BemClass from '@upsales/components/Utils/bemClass';
import { Label, Toggle } from '@upsales/components';
import { useSelector } from 'App/components/hooks';
import { useTranslation } from 'Components/Helpers/translate';
import { RootState } from 'Store/index';
import MarketingChart from 'App/pages/ClientCard/ContentPages/Marketing/MarketingChart';
import MarketHistoryLog from 'App/components/HistoryLog/MarketHistoryLog';
import Contact from 'App/resources/Model/Contact';
import Client from 'App/resources/Model/Client';
import 'App/pages/ClientCard/ContentPages/Marketing/Marketing.scss';

type Props = {
	contact: Contact;
};

const ContactMarket = ({ contact }: Props) => {
	// Reuse the client card Marketing page's BEM root so its stylesheet applies as-is
	const classes = new BemClass('ClientCardContent__Marketing').add('ContactMarket');
	const notesFilterActive = useSelector((state: RootState) => state.NotesFilterActive);
	const { t } = useTranslation();

	const [nrOfMonths, setNrOfMonths] = useState(3);
	const [marketGrouping, setMarketGrouping] = useState('event');
	const [allowZeroEvents, setAllowZeroEvents] = useState(false);

	// The contact's client is a partial shape, but the chart and log only read ids when contact-scoped
	const client = contact.client as unknown as Client;

	return (
		<div className={classes.b()}>
			<MarketingChart
				client={client}
				contact={contact}
				nrOfMonths={nrOfMonths}
				marketGrouping={marketGrouping}
				setNrOfMonths={setNrOfMonths}
				setMarketGrouping={setMarketGrouping}
			/>
			<div className={classes.elem('zeroEventsToggle').b()}>
				<Label>{t('market.includeEventsZeroPoints')}</Label>
				<Toggle checked={allowZeroEvents} onChange={checked => setAllowZeroEvents(checked)} />
			</div>
			<MarketHistoryLog
				client={client}
				contact={contact}
				renderedBy={{ type: 'contact', id: contact.id }}
				notesFilterActive={notesFilterActive}
				cardAdditionalProps={{ hasAvatar: true }}
				allowZeroEvents={allowZeroEvents}
			/>
		</div>
	);
};

export default ContactMarket;
